import { Modal, Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import timestamp from '../../../../assecs/plugin/timestamp';
import { setMessage } from '../../../../store/components/alertSlice';
import { resetModel } from '../../../../store/components/modelSlice';
import { 
    postChargingResendBonusPoint,
    putChargingReissueInvoice,
    postChargingRefund,
    postChargingInvalidInvoice,
    postChargingReturnBonus } from '../../../../services/dashboard/charge';

// --- 資料設定 (Data Configuration) ---
const modalConfigs = {
    resendPoint: {
        type: 'confirm',
        title: '重贈點數',
        content: ({ item }) => `此筆交易已有付款完成，但是點數回饋失敗，是否確認重新贈送點數 ${ item.bonusAdd } 點？`,
        api: ({ uid }) => postChargingResendBonusPoint({ uid }),
    },
    resendInvoice: {
        type: 'confirm',
        title: '重開發票',
        content: ({ item }) => `此筆交易發票狀態為失敗，是否確認重新開立發票？`, // 修正 content 內容
        api: ({ uid }) => putChargingReissueInvoice({ uid }), // 假設重開發票使用這個 API
    },
    refund: {
        type: 'confirm',
        title: '第1步：退款1',
        content: ({ item }) => `是否確認退款，金額 ${ item.tradeAmount } 元？`,
        hint: '此操作僅會退款，不會作廢折讓發票與收還點數',
        api: ({ uid, payVendor }) => postChargingRefund({ uid, payVendor }),
    },
    invalidInvoice: {
        type: 'confirm',
        title: '第2步：作廢/折讓發票',
        content: ({ item }) => {
            // 使用您的 timestamp 工具進行月份比較
            const isSameMonth = timestamp.isCurrentMonth(item.invoiceDate);
            const actionText = isSameMonth ? '作廢' : '折讓';
            return `是否確認 **${actionText}** 發票，發票號碼 ${item.invoiceNo}？`;
        },
        hint: '此操作僅會作廢/折讓發票，不會退費與收還點數',
        api: ({ uid }) => postChargingInvalidInvoice({ uid }),
    },
    returnBonus: { // 修正為 returnBonus
        type: 'confirm',
        title: '第3步：收還點數',
        content: ({ item }) => `是否確認收回贈送的 ${item.bonusAdd ?? 0} 點，並歸還客戶使用的 ${ item.bonusDiscount ?? 0 } 點？`,
        hint: '此操作僅會收還點數，不會退費和作廢折讓發票',
        api: ({ uid }) => postChargingReturnBonus({ uid }),
    }
};

// --- 組件 (Component) ---
const ChargingModal = () => {
    const dispatch = useDispatch();
    // 從 Redux Store 讀取狀態
    const data = useSelector(state => state.model.data);
    
    const isShow = !!data?.type; 
    const config = modalConfigs[data?.type];

    // 關閉函式：透過 dispatch 清空 Redux state
    const cancelHandler = () => { dispatch(resetModel()); };

    // 處理確認操作
    const handleConfirm = async () => {
        if (!config || !config.api) {
            dispatch(setMessage({ message: '無此操作設定' }));
            cancelHandler();
            return;
        }

        let message;
        let success = false; // 新增標記，判斷是否成功
        try {
            // 傳入 uid 進行 API 呼叫
            let resp = await config.api({ uid: data?.uid, payVendor: data?.item?.payVendor });
            message = '操作成功';
            success = true; // 設置成功標記

            if (resp.code !== 'EC000') {
                message = resp.message;
                success = false
            }
            
        } catch (error) {
            console.log(error)
            message = error.response?.data?.message || `操作失敗：${error.message}`;
        }
        
        // 💡 關鍵變動：操作成功後，執行傳入的 reloadList 函式
        if (success && data?.reloadList) {
            // 執行 ChargeManage 傳過來的 getSourceHandler 函式
            data.reloadList(); 
        }

        dispatch(setMessage({ message }));
        cancelHandler(); // 關閉 Modal
    };

    if (!isShow || !config) return null; 

    // 提取 item 資料給 content/hint 函式使用
    const itemData = data?.content || data?.item || data; 

    const size = config.type === 'confirm' ? 'ml' : config.type === 'table' ? 'xl' : 'lg';
    const modalTitle = config.title;

    return (
        <Modal size={size} className="backstage-model" show={isShow} onHide={cancelHandler} centered>
            <Modal.Header className="model_title" closeButton>{modalTitle}</Modal.Header>
            <Modal.Body>
                {/* 渲染 Modal 內容 */}
                
                {/* Text Type 假設是給明細使用 */}
                {config.type === 'text' && (
                    <div style={{ padding: '10px', background: '#f8f9fa', borderRadius: '4px' }}>
                        <pre>{typeof config.content === 'function' ? config.content({ item: itemData }) : config.content}</pre>
                    </div>
                )}
                
                {/* Confirm Type */}
                {config.type === 'confirm' && (
                    <>
                        <div style={{ textAlign: 'center', fontSize: '1.1rem', fontWeight: 'bold' }}>
                            {/* 將 itemData 傳入 config.content 函式 */}
                            {typeof config.content === 'function' ? config.content({ item: itemData }) : config.content}
                        </div>
                        {config.hint && (
                            <div style={{ textAlign: 'center', color: '#b51722', marginTop: '10px', fontSize: '0.9rem' }}>
                                {typeof config.hint === 'function' ? config.hint({ item: itemData }) : config.hint}
                            </div>
                        )}
                    </>
                )}
                
                {/* Modal 按鈕區塊 */}
                <div className="button-container" style={{ marginTop: '20px' }}>
                    <Button variant="secondary" data-shadow onClick={cancelHandler}>關閉</Button>
                    {config.type === 'confirm' && (
                        <Button variant="primary" data-shadow onClick={handleConfirm}>確定</Button>
                    )}
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ChargingModal;